import React from 'react';

// Constants
import { EmptyStateOptions } from './EmptyStateConstants.constants';

// Components
import CreateGoalButtonContainer from 'Shared/components/Goals/CreateGoalButtonContainer/CreateGoalButtonContainer';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

type Props = {
  variant:
    | 'workspaceNoGoals'
    | 'workspaceOpenNonecomplete'
    | 'workspaceOpenSomeComplete'
    | 'teamOpenSomeCompleted'
    | 'teamOpenNoneCompleted'
    | 'teamCompleted';
};

const TeamPageEmptyState = ({ variant }: Props) => {
  const emptyStateContent = EmptyStateOptions.find(options => options.id === variant);

  return (
    <div className="p-4">
      <EmptyStateContainer
        title={emptyStateContent.title}
        subTitle={emptyStateContent.subtitle}
        image={emptyStateContent.imgSrc}
        button={emptyStateContent.showCreateButton && <CreateGoalButtonContainer />}
      />
    </div>
  );
};

export default TeamPageEmptyState;
